import type { Nullable } from '@ricoh/ria.client.core/types/core/data.type';
import type moment from 'moment';
import type { Moment, MomentInput } from 'moment';

import type { DateTimePatternJSON } from './_.type';

import datetimeConfig from '../_config';

const { format } = datetimeConfig;

/**
 * Nullable moment.
 *
 * @param {Nullable<MomentInput>} input Input data.
 * @param {boolean} isLocal Is local.
 *
 * @returns {Nullable<Moment>} Nullable moment.
 */
export function nullable(this: typeof moment, input: Nullable<MomentInput>, isLocal: boolean = false): Nullable<Moment> {
  if (!input) {
    return null;
  }

  if (!isLocal || input instanceof Date) {
    return this(input);
  }

  if (typeof input !== 'string') {
    return null;
  }

  const str = input.replace('Z', '');
  return str ? this(str) : null;
}

/**
 * Nullable pattern moment.
 *
 * @param {Partial<DateTimePatternJSON>} input Input data.
 *
 * @returns {Nullable<Moment>} Nullable moment.
 */
export function nullablePattern(this: typeof moment, input: Partial<DateTimePatternJSON>): Nullable<Moment> {
  let datetime: Moment | undefined;
  if (input.date) {
    datetime = this(input.date, format.json.date);
  } else if (input.time) {
    datetime = this(input.time, format.json.time);
  } else {
    return null;
  }

  return datetime.isValid() ? datetime : null;
}
